import { ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-energy-type-icon',
  templateUrl: './energy-type-icon.component.html',
  styleUrls: ['./energy-type-icon.component.scss'],
})
export class EnergyTypeIconComponent implements OnChanges {
  @Input() iconName: string = '';
  @Input() isIconActive: boolean = false;

  isProducerHovered = false;
  constructor(private ref: ChangeDetectorRef) {}

  public hoverLegendEvent(show: boolean): void {
    this.isProducerHovered = show;
    this.ref.detectChanges();
  }

  public ngOnChanges(): void {
    this.ref.detectChanges();
  }
}
